import React, { useEffect, useState } from 'react';
import api from '../api';
import ProductCard from './ProductCard';
import './ProductList.css';

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedType, setSelectedType] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await api.get('/api/products/');
        setProducts(response.data);
        setFilteredProducts(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching products:', error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    let filtered = products;

    // Filter by type
    if (selectedType !== 'all') {
      filtered = filtered.filter(p => p.product_type === selectedType);
    }

    // Filter by search term
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(p => 
        p.title.toLowerCase().includes(term) ||
        (p.summary && p.summary.toLowerCase().includes(term)) ||
        (p.description && p.description.toLowerCase().includes(term))
      );
    }

    setFilteredProducts(filtered);
  }, [selectedType, searchTerm, products]);

  const handleTypeChange = (e) => {
    setSelectedType(e.target.value);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="product-list-container">
      <div className="product-list-header">
        <h1>Product Catalog</h1>
        <p>Browse our collection of ebooks, audiobooks, games, and podcasts</p>
      </div>

      {/* Filter and Search Section */}
      <div className="filter-bar">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search products..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
        
        <div className="filter-dropdown">
          <label htmlFor="product-type-filter">Type:</label>
          <select 
            id="product-type-filter" 
            value={selectedType} 
            onChange={handleTypeChange}
          >
            <option value="all">All Types</option>
            <option value="ebook">E-Books</option>
            <option value="audiobook">Audiobooks</option>
            <option value="game">Games</option>
            <option value="podcast">Podcasts</option>
          </select>
        </div>
      </div>

      {/* Results count */}
      <div className="results-info">
        Showing {filteredProducts.length} of {products.length} products
      </div>

      {/* Product Grid */}
      {loading ? (
        <div className="loading">Loading products...</div>
      ) : filteredProducts.length > 0 ? (
        <div className="product-grid">
          {filteredProducts.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      ) : (
        <div className="no-products">
          <p>No products found matching your criteria.</p>
        </div>
      )}
    </div>
  );
};

export default ProductList;
